import { Button, notification } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import {
  CatalogData,
  createCatalog,
  getCatalogById,
  TradingProductForCatalog,
} from '../../service/trading';
import { v1 as uuidv1 } from 'uuid';
import { ProductOpValue } from '../../common/components/CatalogRenderer/types';
import { Cover } from './Cover';
import { Page } from './Page';
import chunk from 'lodash/chunk';
import StickyWrapper from '../components/StickyWrapper';
import CreateCatalogModal from '../Trading/CreateCatalogModal';

type CatelogDataPreview = Omit<CatalogData, 'selected_products'> & {
  selected_products: Array<TradingProductForCatalog & ProductOpValue>;
};

const convertToCatalogFormValues = (catalogJson: CatelogDataPreview) => {
  return {
    client: catalogJson.client,
    title: catalogJson.title,
    keyword: catalogJson.keyword,
    email: catalogJson.email,
    companyName: catalogJson.companyName,
    location: catalogJson.location,
    selected_products: catalogJson.selected_products.map((product) => {
      const productJson = product.product_json;
      try {
        const productValues = productJson ? JSON.parse(productJson) : {};
        return productValues;
      } catch (e) {
        console.error(e);
        return {};
      }
    }),
  };
};

const Index = () => {
  const [createLoading, setCreateLoading] = useState(false);
  const searchParams = window.location.search;
  const catalogId = new URLSearchParams(searchParams).get('catalog_id');

  const [catalogJson, setCatalogJson] = useState<CatelogDataPreview>();
  const [editModalVisible, setEditModalVisible] = useState(false);

  const loadCatalog = async (catalogId: string) => {
    try {
      const { catalog } = await getCatalogById({ uuid: catalogId });
      setCatalogJson(catalog);
    } catch (err) {
      notification.error({
        message: '获取产品目录失败',
        description: String(err),
      });
    }
  };

  useEffect(() => {
    if (catalogId) {
      loadCatalog(catalogId);
    } else {
      try {
        const rawData = localStorage.getItem('CATALOG.KEY') ?? '';
        setCatalogJson(rawData ? JSON.parse(rawData) : undefined);
      } catch (e) {
        console.error(e);
      }
    }
  }, [catalogId]);

  const handleClick = async (values: CatalogData) => {
    const catalog_id = uuidv1();
    const {
      client,
      title,
      keyword,
      email,
      companyName,
      location,
      selected_products,
    } = values;
    const products = selected_products.map((p: any) => [
      catalog_id,
      p.uuid,
      p.product_json,
    ]);
    try {
      setCreateLoading(true);
      await createCatalog({
        uuid: catalog_id,
        client,
        title,
        keyword,
        email,
        companyName,
        location,
        products,
      });
      notification.success({ message: '电子目录保存成功' });
    } catch (err) {
      notification.error({
        message: '保存产品目录失败',
        description: String(err),
      });
    } finally {
      setCreateLoading(false);
    }
  };

  const products = useMemo(
    () => (catalogJson ? chunk(catalogJson?.selected_products, 3) : []),
    [catalogJson]
  );

  return (
    <div>
      <CreateCatalogModal
        visible={editModalVisible}
        onCancel={() => setEditModalVisible(false)}
        selectedProducts={
          catalogJson?.selected_products?.map((p) => {
            let descriptions = '';
            let imgUrl = '';
            let title = '';
            let size = '';
            let itemNumber = '';
            try {
              const productValues = JSON.parse(p.product_json || '');
              itemNumber = productValues.item_number;
              descriptions = productValues.desc;
              imgUrl = productValues.image_url;
              title = productValues.title;
              size = productValues.size;
            } catch (e) {
              console.error(e);
            }
            return {
              descriptions,
              img_url: imgUrl,
              product_name: title,
              product_size: size,
              item_number: itemNumber,
            };
          }) || ([] as any)
        }
        formValues={
          catalogJson ? convertToCatalogFormValues(catalogJson) : undefined
        }
      ></CreateCatalogModal>
      <Cover
        title={catalogJson?.title}
        keyword={catalogJson?.keyword}
        email={catalogJson?.email}
        companyName={catalogJson?.companyName}
        location={catalogJson?.location}
      />
      {products.map((item, index) => (
        <Page key={index} products={item} />
      ))}
      {!catalogId && (
        <StickyWrapper>
          <Button
            onClick={() => {
              catalogJson && handleClick(catalogJson);
            }}
            loading={createLoading}
            type="primary"
          >
            保存
          </Button>
        </StickyWrapper>
      )}
      {catalogId && (
        <StickyWrapper>
          <Button onClick={() => setEditModalVisible(true)} type="primary">
            编辑
          </Button>
        </StickyWrapper>
      )}
    </div>
  );
};

export default Index;
